export function toGraphId(address: string | undefined | null) {
  return address?.toLowerCase() ?? ''
}
